<script>
	import { createEventDispatcher } from 'svelte';
    let cls = "sui-textarea";
    export let rows = 2;
    export let placeholder = "";
    export let maxLength = -1;
    export let defaultValue = "";
    export let showCount = false;
    export let id = "";
    export let disabled = false;
    export let readonly = false;
    export let autoSize = false;
    const dispatch = createEventDispatcher();
    let el;
    let h = `auto`;

    function handleInput() {
        dispatch('change',defaultValue)
        if(!autoSize) return;
        h = `auto`;
        window.requestAnimationFrame(function () {
            h = el.scrollHeight + "px";
        });
    }
</script>

<div class={`${cls}-wrapper`}>
    <textarea
        {id}
        class={cls}
        {rows}
        {disabled}
        {readonly}
        {placeholder}
        bind:value={defaultValue}
        maxlength={maxLength}
        bind:this={el}
        style:height={h}
        on:input={handleInput}
        on:blur
        on:focus
    />
    {#if showCount}
        <div class={`${cls}-count`}>
            {defaultValue.length}
            {#if maxLength > 0}
            /
            <b>{maxLength}</b>
            {/if}
        </div>
    {/if}
</div>

<style lang="less">
    @import "./textarea.less";
</style>
